import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="react-print-none">
                                                <ol className="brownbullet-list listcontentSpacing" start="4">
                                                    <li><p><span className="subtiltereg">Can you reframe your belief based on this information?</span><br/>I
                                                        gave a bad presentation on this occasion for various
                                                        reasons, but I have shown in the past
                                                        that I can give good presentations.</p></li>
                                                    <li><p><span className="subtiltereg">Visualise the situation going better next time. What does this look like?</span><br/>I
                                                        would be better prepared and more able to deal with
                                                        PowerPoint if it crashed. I would
                                                        remain calm.</p></li>
                                                    <li><p><span className="subtiltereg">What small step can I take right now to move towards this?</span><br/>I
                                                        can enrol on the in-house PowerPoint course. I can ensure
                                                        that I go to bed early before a big
                                                        presentation and give myself more time for preparation and
                                                        potential last-minute changes.</p></li>
                                                </ol>
                                                <p></p>
                                            </div>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>HOW TO COUNTER NEGATIVE SELF-TALK
                                            </div>
                                            <p>As we go about our lives, we all 'self-talk', which is our inner
                                                voice saying such things as, 'I'm really
                                                looking forward to that game'. However, sometimes that self-talk
                                                can be negative and hamper us,
                                                such as when a test is coming up and we say to ourselves 'I'm
                                                going to fail for sure', thereby
                                                sowing the seeds of our own downfall.</p>
                                            <p>The most effective way to resist persistent negative self-talk is
                                                to challenge it with positive,
                                                realistic analysis. The tool below is designed to help you
                                                analyse and challenge negative self-talk
                                                by looking at it objectively and giving you the platform to
                                                challenge and defeat it, preventing it
                                                from bringing down your natural potential.</p>

                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />

                                            <p><b>Tool to analyse your self-talk</b></p>


                                            <table className="ilead_v_sport tablesrink uiheading" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve " align="left" valign="top"
                                                        width="40%">Question
                                                    </th>
                                                    <th className="whiteBGheading" align="left" valign="top"
                                                        width="5%"></th>
                                                    <th className=" green_curve1" align="left" valign="top"
                                                        width="20%">Your Response
                                                    </th>

                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>Identify when you have been aware of
                                                        negative self-talk.</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response1"
                                                                      value={this.props.pageData?.Response1}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>Describe the situation or the statements
                                                        used.</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response2"
                                                                      value={this.props.pageData?.Response2}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>Identify the evidence of this being
                                                        true.</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response3"
                                                                      value={this.props.pageData?.Response3}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>Is this always the case?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response4"
                                                                      value={this.props.pageData?.Response4}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>Have you found this to be true in the
                                                        past?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response5"
                                                                      value={this.props.pageData?.Response5}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>How likely is this to be true or really
                                                        happening?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response6"
                                                                      value={this.props.pageData?.Response6}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>What is the very worst that could happen?
                                                        How would you react to this?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response7"
                                                                      value={this.props.pageData?.Response7}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>Is your picture of beliefs balanced?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response8"
                                                                      value={this.props.pageData?.Response8}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>Are you being objective?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response9"
                                                                      value={this.props.pageData?.Response9}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>What is the consequence of you continuing
                                                        in this frame of mind?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response10"
                                                                      value={this.props.pageData?.Response10}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>What would you say to a friend that had
                                                        this frame of mind?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response11"
                                                                      value={this.props.pageData?.Response11}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="middle"
                                                        width="40%"><p>What can you to do about this now?</p>
                                                    </td>
                                                    <td className="whiteBGheading" align="left" valign="middle"
                                                        width="5%">
                                                        <div className="">
                                                            <img
                                                                src={require('@images/arrow1.1.png')}
                                                                alt="" className="rotated_arrow"/>
                                                        </div>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <div className="paraspace">
                                                            <textarea className="TaskTextArea1"
                                                                      name="Response12"
                                                                      value={this.props.pageData?.Response12}
                                                                      onChange={this.props.handleChangeTextarea}/>
                                                        </div>
                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="react-print-none">
                                                <div className="border_subtitle">Seek inspiration</div>
                                                <p>Find something that inspires you (such as a book of quotations or
                                                    autobiographies of successful
                                                    people in your field) and use it daily.</p>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}